import Support from '../../components/Help/Support';

const SupportPage = () => {
  return <Support />;
};

export default SupportPage;
